/*
 * Copyright (c) 2010 Macrofocus GmbH. All Rights Reserved.
 */
package org.mkui.colormap

import com.macrofocus.common.collection.CollectionFactory
import com.macrofocus.common.collection.WeakReference

/**
 * This class provides a skeletal implementation of the Colormap interface to minimize the effort required to implement this interface.
 */
abstract class AbstractColorMap protected constructor() : ColorMap {
    enum class PropertyType {
        Inverval, Palette, Matching, Assignments, MissingValuesColor, UnderflowColor, OverflowColor, Inverted, NumberOfSteps, Brightness, Saturation, Alpha
    }

    private val listeners: MutableList<ColorMapListener>
    override fun addColorMapListener(listener: ColorMapListener) {
        listeners.add(listener)
    }

    override fun addWeakColorMapListener(listener: ColorMapListener) {
        listeners.add(WeakColorMapListener(listener))
    }

    override fun removeColorMapListener(listener: ColorMapListener) {
        if (listener is WeakColorMapListener) {
            val removed = listeners.remove(listener)
        } else {
            var toRemove: ColorMapListener? = null
            for (ColormapListener in listeners) {
                var comparable: ColorMapListener?
                comparable = if (ColormapListener is WeakColorMapListener) {
                    ColormapListener.reference
                } else {
                    ColormapListener
                }
                if (listener == comparable) {
                    toRemove = ColormapListener
                }
            }
            if (toRemove != null) {
                val removed = listeners.remove(toRemove)
            }
        }
    }

    fun removeColormapListeners() {
        listeners.clear()
    }

    protected fun notifyColorMapChanged(event: ColorMapEvent) {
        for (listener in listeners) {
            listener.colorMapChanged(event)
        }
    }

    private class WeakColorMapListener(listener: ColorMapListener) : ColorMapListener {
        private val l_ref: WeakReference<ColorMapListener>
        override fun colorMapChanged(event: ColorMapEvent) {
            val l: ColorMapListener? = reference
            if (l != null) {
                l.colorMapChanged(event)
            } else {
                event.getColorMap().removeColorMapListener(this)
            }
        }

        val reference: ColorMapListener?
            get() = l_ref.get()

        init {
            l_ref = WeakReference(listener)
        }
    }

    init {
        listeners = CollectionFactory.copyOnWriteArrayList()
    }

    companion object {
        const val PROPERTY_INTERVAL = "inverval"
        const val PROPERTY_PALETTE = "palette"
        const val PROPERTY_MATCHING = "matching"
        const val PROPERTY_ASSIGNMENTS = "assignments"
        const val PROPERTY_NULLCOLOR = "missingValuesColor"
        const val PROPERTY_UNDERCOLOR = "underflowColor"
        const val PROPERTY_OVERCOLOR = "overflowColor"
        const val PROPERTY_INVERTED = "inverted"
        const val PROPERTY_COLORCOUNT = "numberOfSteps"
        const val PROPERTY_BRIGHTNESS = "brightness"
        const val PROPERTY_SATURATION = "saturation"
        const val PROPERTY_ALPHA = "alpha"
    }
}